/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_Filter_All_CategoriesInputs */



/**
* | output |
* | --- |
* | "All categories" |
*
* @param {User_Detail_Filter_All_CategoriesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_filter_all_categories = /** @type {((inputs?: User_Detail_Filter_All_CategoriesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Filter_All_CategoriesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les catégories")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todas las categorías")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todas as categorias")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutte le categorie")
	return /** @type {LocalizedString} */ ("All categories")
});